import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';


// Services 
import { ControllerService } from '../../../services/controller/controller.service';
import { LanguageService } from '../../../services/language/language.service';


@Component({
  selector: 'app-admin-page',
  imports: [],
  templateUrl: './admin-page.component.html',
  styleUrl: './admin-page.component.css'
})
export class AdminPageComponent {

  constructor(
    public controllerService:ControllerService,
    public languageService:LanguageService,
    ){}

    navigate(route:string){
      this.controllerService.navigate(route)
    }

}
